import './styles.scss'

function CreditPointsCard(
    {
        date,
        title,
        score,
        bgColor="#f5f5f5"
    }
) {
    return (
        <div className="creditPointscard-container" style={{backgroundColor:bgColor}}>
            <div className="creditPointscard-header">
                <p>
                    {date}
                </p>
                <h5>
                    {title}
                </h5>
            </div>
            <div className="creditPointscard-score">
                {score}
            </div>

        </div>
    );
}

export default CreditPointsCard;